export default "__VITE_ASSET__B4_c634D__"